import { render, staticRenderFns } from "./AdminUserStats.vue?vue&type=template&id=f4fffc40"
import script from "./AdminUserStats.vue?vue&type=script&lang=ts"
export * from "./AdminUserStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports